

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import type { CombinedUser } from "@/lib/collections/workerProfile-Users/getUserWithProfile";
import { Link } from "@tanstack/react-router";
import { File, Files } from "lucide-react";

type EmploymentCertificateProps = {
    user: CombinedUser;
};

const RequestUser = ({ user }: EmploymentCertificateProps) => {
    return (
        <><>
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <div className="flex items-center gap-1.5">
                            <Files />
                            <BreadcrumbPage>Solicitudes</BreadcrumbPage>
                        </div>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink asChild>
                            <Link to="/requests">Menu</Link>
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage className="hidden sm:block">{user.name}</BreadcrumbPage>
                        <BreadcrumbPage className="block sm:hidden "> <File className="w-5 h-5" /> </BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>


        </>
            {/* <AddCertificateRequest /> */}

        </>
    )
}



export default RequestUser